export default __webpack_public_path__ + "static/media/location_icon_transparent.3bb16779.svg";